import moment from "moment";
import { FormatNumber2 } from "../../utility/functions/formatNumber";
import React from "react";
import { useSelector } from "react-redux";
import { selectPrefix } from "../../utility/Redux/profile";
import { CallAPIPromise } from "../../billing/common";
const ChequeClearDateCell = ({ params ,okButton}) => {
  const [selectedDate, setSelectedDate] = React.useState(
    params.value ? moment(params.value).format('YYYY-MM-DD') : ''
  );
const tablePrefix = useSelector(selectPrefix)
  const [loading, setLoading] = React.useState(false);

  const handleUpdate = async () => {
    if (!selectedDate) return;

    setLoading(true);
    CallAPIPromise("/api/voucher/updateChequeClearance",{
      table_prefix: tablePrefix ,
      VOUCHER_NO: params.row.original.VOUCHER_NO,
      CHEQUE_CLEAR_DATE: selectedDate,
    }).then( (res)=>{
       }).finally(()=>{
        okButton()
        setLoading(false);
       })
  

  };
if(params.value){
  return <div className="flex items-center gap-2 w-full">

<span style={{  }}>
        {params.value
          ? moment(params.value).format('DD-MM-YYYY')
          : ''}
      </span>
    </div>
}
  return (
    <div className="flex items-center gap-2 w-full">
      
      <input
        type="date"
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
        className="border px-1 py-[2px] text-xs rounded"
      />

      <button
        onClick={handleUpdate}
        disabled={!selectedDate || loading}
        className="bg-blue-500 text-white px-2 py-[2px] text-xs rounded"
      >
        {loading ? "..." : "Update"}
      </button>

      <span style={{  }}>
        {selectedDate
          ? moment(selectedDate).format('DD-MM-YYYY')
          : ''}
      </span>
    </div>
  );
};
export const SummaryColumns = (width,okButton) => {
    const columns = [
      {
        field: 'VOUCHER_NO',
        accessor: 'VOUCHER_NO',

        type: 'string',
        headerAlign: 'center',
        width: width < 768 ? 150 : width < 1400 ? 80 : 60,
        headerClassName: 'super-app-theme--header',
  
        renderCell: (param) => {
          return (
            <div
              className={`h-full w-full  flex items-center   `}
            >
              {param.value}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            {'Voucher'}{' '}
          </div>
        ),
      },

      {
        field: 'DATE',
        accessor: 'DATE',
        type: 'string',
        type:'text',
        headerAlign: 'center',
        width: width < 768 ? 100 : 100,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
          return (
            <div
              className={`h-full w-full flex items-center  `}
            >
              {moment(params.value).format('DD-MM-YYYY')}{' '}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            {'Date'}{' '}
          </div>
        ),
      },
      {
        field: 'VOUCHER_TYPE',
        accessor: 'VOUCHER_TYPE',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 120,
        align: 'left',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  `}
            >
              {param.value }
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
    Voucher Type
          </div>
        ),
      },
      {
        field: 'ACCOUNT_NO',
        accessor: 'ACCOUNT_NO',
        type: 'string',
        width: width < 768 ? 100 : 60,
        headerAlign: 'center',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center   `}
            >
              {param.value}
            </div>
          );
        },
        headerClassName: 'super-app-theme--header',
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            {'Acc. No.'}{' '}
          </div>
        ),
      },
      {
        field: 'NAME',
        accessor: 'NAME',
        type: 'string',
        width: width < 768 ? 100 : width < 1400 ? 180 : 210,
        headerClassName: 'super-app-theme--header',
        headerAlign: 'center',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center   `}
            >
              {param.value}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            Party Name
          </div>
        ),
      },
      {
        field: 'MOBILE',
        accessor: 'MOBILE',
        type: 'number',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center   `}
            >
              {param.value}
            </div>
          );
        },
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 130,
        headerAlign: 'center',
        align: 'left',
  
        renderHeader: (params) => (
          <div
            className="text-white  whitespace-normal"
            style={{ fontSize: 13 }}
          >
            {' '}
            Mobile
          </div>
        ),
      },
      
      {
        field: 'DEBIT',
        accessor: 'DEBIT',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 90,
        align: 'right',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  justify-end `}
            >
              {param.value ? FormatNumber2(param.value) : ''}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
            Debit
          </div>
        ),
      },
      {
        field: 'CREDIT',
        accessor: 'CREDIT',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 90,
        align: 'right',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  justify-end `}
            >
              {param.value !== "0" ? FormatNumber2(param.value) : ''}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
Credit
          </div>
        ),
      },
    
      {
        field: 'DESC_NAME',
        accessor: 'DESC_NAME',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 160,
        align: 'left',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  `}
            >
              {param.value}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
   Description
          </div>
        ),
      },
         {
        field: 'PAY_MODE',
        accessor: 'PAY_MODE',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 80,
        align: 'left',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  `}
            >
              {param.value}
            </div>
          );
        },
        headerAlign: 'center',
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
        Paymode
          </div>
        ),
      },
      {
        field: 'BANK_NAME',
        accessor: 'BANK_NAME',
        type: 'text',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 160,
        align: 'left',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  `}
            >
              {param.value}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
   Bank Name
          </div>
        ),
      },
      {
        field: 'CHEQUE_NO',
        accessor: 'CHEQUE_NO',
        type: 'text',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 160,
        align: 'left',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  `}
            >
              {param.value}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
Cheque No.
          </div>
        ),
      },
      {
        field: 'CHEQUE_DATE',
        accessor: 'CHEQUE_DATE',
        type: 'string',
        type:'text',
        headerAlign: 'center',
        width: width < 768 ? 100 : 100,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
          return (
            <div
              className={`h-full w-full flex items-center  `}
            >
              {moment(params.value).format('DD-MM-YYYY')}{' '}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            {'Cheque Date'}{' '}
          </div>
        ),
      },
      {
        field: 'REMARKS',
        accessor: 'REMARKS',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 150,
        align: 'left',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  `}
            >
              {param.value}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
       Remarks
          </div>
        ),
      },
      {
        field: 'CHEQUE_CLEAR_DATE',
        accessor: 'CHEQUE_CLEAR_DATE',
        headerAlign: 'center',
        width: 200,
        headerClassName: 'super-app-theme--header',
      
        renderCell: (params) => <ChequeClearDateCell okButton={okButton} params={params} />,
      
        renderHeader: () => (
          <div className="text-white text-center" style={{ fontSize: 13 }}>
            Clear Date
          </div>
        ),
      }
    ];


    const tabColumns = [
      {
        field: 'VOUCHER_NO',
        accessor: 'VOUCHER_NO',

        type: 'string',
        headerAlign: 'center',
        width: width < 768 ? 150 : width < 1400 ? 80 : 60,
        headerClassName: 'super-app-theme--header',
  
        renderCell: (param) => {
          return (
            <div
              className={`h-full w-full  flex items-center   `}
            >
              {param.value}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            {'Voucher'}{' '}
          </div>
        ),
      },

      {
        field: 'DATE',
        accessor: 'DATE',
        type: 'string',
        type:'text',
        headerAlign: 'center',
        width: width < 768 ? 100 : 100,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
          return (
            <div
              className={`h-full w-full flex items-center  `}
            >
              {moment(params.value).format('DD-MM-YYYY')}{' '}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            {'Date'}{' '}
          </div>
        ),
      },
      {
        field: 'VOUCHER_TYPE',
        accessor: 'VOUCHER_TYPE',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 120,
        align: 'left',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  `}
            >
              {param.value }
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
    Voucher Type
          </div>
        ),
      },
      {
        field: 'NAME',
        accessor: 'NAME',
        type: 'string',
        width: width < 768 ? 100 : width < 1400 ? 180 : 210,
        headerClassName: 'super-app-theme--header',
        headerAlign: 'center',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center   `}
            >
              {param.value}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            Party Name
          </div>
        ),
      },
      {
        field: 'MOBILE',
        accessor: 'MOBILE',
        type: 'number',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center   `}
            >
              {param.value}
            </div>
          );
        },
        headerClassName: 'super-app-theme--header',
        width: 100,
        headerAlign: 'center',
        align: 'left',
  
        renderHeader: (params) => (
          <div
            className="text-white  whitespace-normal"
            style={{ fontSize: 13 }}
          >
            {' '}
            Mobile
          </div>
        ),
      },
 
      {
        field: 'DEBIT',
        accessor: 'DEBIT',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 90,
        align: 'right',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  justify-end `}
            >
              {param.value ? FormatNumber2(param.value) : ''}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
            Debit
          </div>
        ),
      },
      {
        field: 'CREDIT',
        accessor: 'CREDIT',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 90,
        align: 'right',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  justify-end `}
            >
              {param.value !== "0" ? FormatNumber2(param.value) : ''}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
Credit
          </div>
        ),
      },
      {
        field: 'DESC_NAME',
        accessor: 'DESC_NAME',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 160,
        align: 'left',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  `}
            >
              {param.value}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
   Description
          </div>
        ),
      },
       {
        field: 'PAY_MODE',
        accessor: 'PAY_MODE',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 80,
        align: 'left',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  `}
            >
              {param.value}
            </div>
          );
        },
        headerAlign: 'center',
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
        Paymode
          </div>
        ),
      },
    
      {
        field: 'BANK_NAME',
        accessor: 'BANK_NAME',
        type: 'text',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 160,
        align: 'left',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  `}
            >
              {param.value}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
   Bank Name
          </div>
        ),
      },
      {
        field: 'CHEQUE_NO',
        accessor: 'CHEQUE_NO',
        type: 'text',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 160,
        align: 'left',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  `}
            >
              {param.value}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
Cheque No.
          </div>
        ),
      },
      {
        field: 'CHEQUE_DATE',
        accessor: 'CHEQUE_DATE',
        type: 'string',
        type:'text',
        headerAlign: 'center',
        width: width < 768 ? 100 : 100,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
          return (
            <div
              className={`h-full w-full flex items-center  `}
            >
              {moment(params.value).format('DD-MM-YYYY')}{' '}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            {'Cheque Date'}{' '}
          </div>
        ),
      },
    
    ];
const flexExpenseWidth = width - (50+70+70+80 +14)
    const mobileColumns = [
      {
        field: 'VOUCHER_NO',
        accessor: 'VOUCHER_NO',

        type: 'string',
        headerAlign: 'center',
        width:50,
        headerClassName: 'super-app-theme--header',
  
        renderCell: (param) => {
          return (
            <div
              className={`h-full w-full  flex items-center   `}
            >
              {param.value}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            {'Voucher'}{' '}
          </div>
        ),
      },

      {
        field: 'DATE',
        accessor: 'DATE',
        type: 'string',
        type:'text',
        headerAlign: 'center',
        width: 70,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
          return (
            <div
              className={`h-full w-full flex items-center  `}
            >
              {moment(params.value).format('DD-MM-YYYY')}{' '}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            {'Date'}{' '}
          </div>
        ),
      },
   
  
    
      {
        field: 'DEBIT',
        accessor: 'DEBIT',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: 70,
        align: 'right',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  justify-end `}
            >
              {param.value ? FormatNumber2(param.value) : ''}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
            Debit
          </div>
        ),
      },
      {
        field: 'CREDIT',
        accessor: 'CREDIT',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: 70,
        align: 'right',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  justify-end `}
            >
              {param.value !== "0" ? FormatNumber2(param.value) : ''}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
Credit
          </div>
        ),
      },
      {
        field: 'EXPENSE_NAME',
        accessor: 'EXPENSE_NAME',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width:flexExpenseWidth,
        align: 'left',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  `}
            >
              {param.value}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
     Expense Name
          </div>
        ),
      },
    
    
   
    
    ];
    return width <764? mobileColumns: columns;
  };